module.exports = __webpack_public_path__ + "static/media/iconSussesTextFied.b5b1e3e8.svg";